
import logo from './Verdure Brand Logo .png';
import './footer.css';

const FooterReal = () => {
    return (
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo-section">
            <img src={logo} alt="Verdure Logo" className="footer-logo" />
            <p className="footer-tagline">Live UR Life a Little Greener</p>
          </div>
          
          <div className="footer-links-section">
            <div className="footer-column">
              <h3 className="footer-heading">About</h3>
              <ul className="footer-links">
                <li><a href="/our-story">Our Story</a></li>
                {/* <li><a href="/brands">Brands</a></li> */}
                <li><a href="/sustainability">Verifying Sustainability</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3 className="footer-heading">Network</h3>
              <ul className="footer-links">
                <li><a href="/partners">Sustainable Partners</a></li>
                <li><a href="/for-businesses">For Businesses</a></li>
                <li><a href="https://urverdure.com" target="_blank" rel="noopener noreferrer">Shrok Blog</a></li>
                <li><a href="https://urverdure.com/ambassador-program" target="_blank" rel="noopener noreferrer">Ambassador Program</a></li>
                <li><a href="https://www.notion.so/Influencer-Partnership-Kit-23139699553880f3bed0ffb828b7d997?source=copy_links">Media Kit/Press</a></li>
                <li><a href="https://instagram.com/ur.verdure" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                <li><a href="https://tiktok.com/urverdure" target="_blank" rel="noopener noreferrer">TikTok</a></li>
                <li><a href="https://urverdure.com/community">Discord</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3 className="footer-heading">Service</h3>
              <ul className="footer-links">
                <li><a href="/faqs">FAQs</a></li>
                <li><a href="mailto:yourverdure@gmail.com">Contact</a></li>
                <li><a href="https://urverdure.com/terms-of-service">Terms of Use</a></li>
                <li><a href="https://urverdure.com/privacy-policy">Privacy Policy</a></li>
                <li><a href="https://urverdure.com/cookies">Cookie Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p> {new Date().getFullYear()} Verdure. </p>
        </div>
      </footer>
    );
  };


export default FooterReal;